import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bottom",
  "use": "bottom-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"bottom\"><defs><style></style></defs><path d=\"M500.899 699.314L132.686 331.102c-6.248-6.248-6.248-16.38 0-22.628 6.248-6.248 16.379-6.248 22.628 0l356.903 356.903 356.901-356.902c6.249-6.248 16.38-6.248 22.628 0 6.249 6.248 6.248 16.379 0 22.627L523.535 699.314A15.95 15.95 0 01512.217 704a15.95 15.95 0 01-11.318-4.686z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol